import { Commerce } from '@interfaces/general';
import { MissingCommerceKeys } from '@pages/Commerce/hooks/commerce';
import { validateCellPhone } from '@utils/validations';

export const validateCommerce = (commerce: Commerce) => {
  const missingKeys: MissingCommerceKeys[] = [];
  // step 1
  if (!commerce.country_code || commerce.country_code === 0) missingKeys.push('country_code');
  if (!commerce.telefono || !validateCellPhone(commerce.telefono.toString())) missingKeys.push('telefono');
  if (!commerce.prefijo_folio) missingKeys.push('prefijo_folio');
  if (!commerce.zona_horaria) missingKeys.push('zona_horaria');

  return missingKeys;
};

export const validateBusinessTypeValues = (commerce: Commerce) => {
  const missingValues: MissingCommerceKeys[] = [];
  // Business type step
  if (!commerce.business_type) missingValues.push('business_type');
  if (!commerce.business_sub_type) missingValues.push('business_sub_type');

  return missingValues;
};

export const validateAddressValues = (commerce: Commerce) => {
  const missingValues: MissingCommerceKeys[] = [];
  // step 2
  if (!commerce.address?.city) missingValues.push('address.city');
  if (!commerce.address?.state) missingValues.push('address.state');
  if (!commerce.address?.postalCode) missingValues.push('address.postalCode');
  if (!commerce.address?.neighborhood) missingValues.push('address.neighborhood');
  if (!commerce.address?.exteriorNumber) missingValues.push('address.exteriorNumber');
  if (!commerce.address?.street) missingValues.push('address.street');
  if (!commerce.address?.fullAddress) missingValues.push('address.fullAddress');
  if (!commerce.address?.latitude || commerce.address.latitude === 0) missingValues.push('address.latitude');
  if (!commerce.address?.longitude || commerce.address.longitude === 0) missingValues.push('address.longitude');

  return missingValues;
};
